import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import I18nText from "../components/I18nText";

export default function Placeholder({ slug }) {
    const { t } = useTranslation();
    const key = ["about", "faq", "privacy", "terms"].includes(slug) ? slug : "about";

    useEffect(() => {
        document.title = `${t(`placeholders.${key}.title`).replace(/<[^>]+>/g, "")} — Laguna Benefits`;
    }, [key, t]);

    return (
        <div className="placeholder-page" data-testid={`placeholder-${key}`}>
            <h1>
                <I18nText i18nKey={`placeholders.${key}.title`} />
            </h1>
            <p className="lead">{t(`placeholders.${key}.lead`)}</p>
            <div className="soon">{t(`placeholders.${key}.soon`)}</div>
        </div>
    );
}
